import { writeBatch, doc, getDoc, serverTimestamp, Timestamp } from "firebase/firestore";


// Defines the 10 test teams with varying skill levels.
// Defines 40 test teams with varying skill levels (highest → lowest).
export const testTeams = [
  { name: "The Quizard of Oz", selfie: "https://images.pexels.com/photos/3184418/pexels-photo-3184418.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1", accuracy: 0.95 },
  { name: "Quiztopher Columbus", selfie: "https://images.pexels.com/photos/5668858/pexels-photo-5668858.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1", accuracy: 0.92 },
  { name: "Les Quizerables", selfie: "https://images.pexels.com/photos/3184433/pexels-photo-3184433.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1", accuracy: 0.90 },
  { name: "E=MC Hammer", selfie: "https://images.pexels.com/photos/7794041/pexels-photo-7794041.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1", accuracy: 0.88 },
  { name: "John Trivialta", selfie: "https://th.bing.com/th/id/OIP.3q5dwNFmi04-l0hv52FopgAAAA?w=186&h=279&c=7&r=0&o=7&cb=12&dpr=1.5&pid=1.7&rm=3", accuracy: 0.86 },
  { name: "The Spanish In-quiz-ition", selfie: "https://th.bing.com/th/id/OIP.YhwrB-Oglkwy99FSDdg7RwHaE7?w=296&h=197&c=7&r=0&o=7&cb=12&dpr=1.5&pid=1.7&rm=3", accuracy: 0.84 },
  { name: "Risky Quizness", selfie: "https://images.pexels.com/photos/8199563/pexels-photo-8199563.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1", accuracy: 0.82 },
  { name: "Let's Get Quizzical", selfie: "https://images.pexels.com/photos/3184431/pexels-photo-3184431.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1", accuracy: 0.80 },
  { name: "For Quiz and Giggles", selfie: "https://images.pexels.com/photos/6457515/pexels-photo-6457515.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1", accuracy: 0.78 },
  { name: "Know-It-Alls", selfie: "https://images.pexels.com/photos/3184465/pexels-photo-3184465.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1", accuracy: 0.76 },
  { name: "Quizteama Aguilera", selfie: "https://images.pexels.com/photos/732425/pexels-photo-732425.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1", accuracy: 0.74 },
  { name: "Victorious Secret", selfie: "https://th.bing.com/th/id/OIP.13uLi8Lr-3GE0h1v5V8bKwHaJ4?w=186&h=248&c=7&r=0&o=7&cb=12&dpr=1.5&pid=1.7&rm=3", accuracy: 0.72 },
  { name: "Universally Challenged", selfie: "https://images.pexels.com/photos/774909/pexels-photo-774909.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1", accuracy: 0.70 },
  { name: "Agatha Quiztie", selfie: "https://images.pexels.com/photos/774866/pexels-photo-774866.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1", accuracy: 0.68 },
  { name: "Hannah Quiztana", selfie: "https://images.pexels.com/photos/614810/pexels-photo-614810.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1", accuracy: 0.66 },
  { name: "Sherlock Homies", selfie: "https://th.bing.com/th/id/OIP.oONfk9r875Lp3bZ90SeckQHaLM?w=186&h=281&c=7&r=0&o=7&cb=12&dpr=1.5&pid=1.7&rm=3", accuracy: 0.64 },
  { name: "Quiz Me Baby One More Time", selfie: "https://th.bing.com/th/id/OIP.9Ubox1hsk7XAwmdZdEW1-gHaJ3?w=186&h=248&c=7&r=0&o=7&cb=12&dpr=1.5&pid=1.7&rm=3", accuracy: 0.62 },
  { name: "Trivia Newton John", selfie: "https://images.pexels.com/photos/415829/pexels-photo-415829.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1", accuracy: 0.60 },
  { name: "Dumbledore’s Army", selfie: "https://images.pexels.com/photos/1681010/pexels-photo-1681010.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1", accuracy: 0.58 },
  { name: "A Quizwork Orange", selfie: "https://images.pexels.com/photos/196652/pexels-photo-196652.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1", accuracy: 0.56 },
  { name: "Quiztefer Robin", selfie: "https://th.bing.com/th/id/OIP.2nNfDbz5-zaIPn1Qcao_vwAAAA?w=186&h=279&c=7&r=0&o=7&cb=12&dpr=1.5&pid=1.7&rm=3", accuracy: 0.54 },
  { name: "The Fact Hunt", selfie: "https://th.bing.com/th/id/OIP.5QeCeKaNP9qxAKN7Y7R4RwHaHa?w=155&h=180&c=7&r=0&o=7&cb=12&dpr=1.5&pid=1.7&rm=3", accuracy: 0.52 },
  { name: "Ctrl-Alt-Elites", selfie: "https://images.pexels.com/photos/1181671/pexels-photo-1181671.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1", accuracy: 0.50 },
  { name: "The Brewsual Suspects", selfie: "https://images.pexels.com/photos/1269042/pexels-photo-1269042.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1", accuracy: 0.48 },
  { name: "Planet of the Grapes", selfie: "https://images.pexels.com/photos/1407857/pexels-photo-1407857.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1", accuracy: 0.46 },
  { name: "Cereal Killers", selfie: "https://m.media-amazon.com/images/I/61iiCKZkm9L._UF1000,1000_QL80_.jpg", accuracy: 0.44 },
  { name: "The Smarty Pints", selfie: "https://th.bing.com/th/id/OIP.xaT-_qOdt-nDvbcbp_6hHwAAAA?w=186&h=279&c=7&r=0&o=7&cb=12&dpr=1.5&pid=1.7&rm=3", accuracy: 0.42 },
  { name: "Quiz in My Pants", selfie: "https://images.pexels.com/photos/1130626/pexels-photo-1130626.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1", accuracy: 0.40 },
  { name: "Questlove", selfie: "https://images.pexels.com/photos/713312/pexels-photo-713312.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1", accuracy: 0.38 },
  { name: "Social Quiztancing", selfie: "https://images.pexels.com/photos/1649771/pexels-photo-1649771.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1", accuracy: 0.36 },
  { name: "The Mighty Morphin Flower Arrangers", selfie: "https://images.pexels.com/photos/461956/pexels-photo-461956.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1", accuracy: 0.34 },
  { name: "Quizzy McQuizface", selfie: "https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1", accuracy: 0.32 },
  { name: "The Beyon-Quiz", selfie: "https://th.bing.com/th/id/OIP.Xud0moYw5-Ua2GJhIoyHLAHaLG?w=186&h=279&c=7&r=0&o=7&cb=12&dpr=1.5&pid=1.7&rm=3", accuracy: 0.30 },
  { name: "Quiz Fitzgerald", selfie: "https://th.bing.com/th/id/OIP.K4GxVterq2PE0RwknHv5GAHaNM?w=186&h=331&c=7&r=0&o=7&cb=12&dpr=1.5&pid=1.7&rm=3", accuracy: 0.28 },
  { name: "Panic! At The Quizco", selfie: "https://media.istockphoto.com/id/1455279536/photo/group-of-four-cheerful-young-friends-taking-selfie-inside-bar-happy-people-looking-at-camera.jpg?s=612x612&w=0&k=20&c=j7cA210LLZ2yjeQoFqhs-gCZl3g9y_yM9VHMyxJ0LJY=", accuracy: 0.26 },
  { name: "The Rolling Scones", selfie: "https://images.pexels.com/photos/263168/pexels-photo-263168.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1", accuracy: 0.24 },
  { name: "It’s Quizness Time", selfie: "https://images.pexels.com/photos/1043471/pexels-photo-1043471.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1", accuracy: 0.22 },
  { name: "The Think Tank", selfie: "https://images.pexels.com/photos/3987024/pexels-photo-3987024.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1", accuracy: 0.20 },
  { name: "Trivia & Error", selfie: "https://images.pexels.com/photos/774909/pexels-photo-774909.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1", accuracy: 0.18 },
  { name: "The Late Submittals", selfie: "https://images.pexels.com/photos/845434/pexels-photo-845434.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1", accuracy: 0.16 }
];

/** Simulator NPC team names (same as `testTeams`) — never pick as round-tag chooser */
export const SIMULATOR_TEAM_NAME_SET = new Set(testTeams.map((t) => t.name));

export function isSimulatorTestTeam(teamName) {
  return SIMULATOR_TEAM_NAME_SET.has(String(teamName || "").trim());
}

/**
 * Ensures test teams exist for the current game, adding them if necessary.
 */
async function ensureTestTeamsExist(db, gameCode, limitCount = testTeams.length) {
  try {
    const count = Math.max(0, Math.min(testTeams.length, Number(limitCount) || 0));
    if (count <= 0) {
      return;
    }
    const selectedTeams = testTeams.slice(0, count);
    const batch = writeBatch(db);
    for (const team of selectedTeams) {
      const teamRef = doc(db, "games", gameCode, "teams", team.name);
      batch.set(
        teamRef,
        { team: team.name, selfieUrl: team.selfie, joinedAt: Date.now() },
        { merge: true } // idempotent; updates selfie if you change it
      );
    }
    await batch.commit();
    console.log(`[Test Data] Ensured ${selectedTeams.length} test teams exist.`);
  } catch (error) {
    console.error("[Test Data] CRITICAL: Failed to add test teams.", error);
  }
}

// Helper function needed for Vanishing Choice simulation
function remainingDisplayIndices(q, elapsedSec) {
  const total = Math.max(1, Number(q.time || 20));
  const n = Array.isArray(q.answersOrder) ? q.answersOrder.length : 0;
  // Fallback if vanishOrder isn't set up correctly
  if (!Array.isArray(q.vanishOrder) || q.vanishOrder.length === 0 || n === 0) {
    return Array.from({ length: n }, (_, i) => i);
  }
  // Calculate how many incorrect options should have vanished
  const numIncorrect = q.vanishOrder.length; // vanishOrder only contains incorrect indices
  const vanishedCount = Math.min(numIncorrect, Math.floor((elapsedSec / total) * numIncorrect));
  const goneOriginalIndices = new Set(q.vanishOrder.slice(0, vanishedCount));

  // Return the DISPLAY indices of answers whose ORIGINAL indices haven't vanished
  return Array.isArray(q.answersOrder)
    ? q.answersOrder
        .map((origIdx, displayIdx) => (goneOriginalIndices.has(origIdx) ? -1 : displayIdx))
        .filter(displayIdx => displayIdx !== -1)
    : Array.from({ length: n }, (_, i) => i); // Fallback if answersOrder is missing
}

/**
 * Generates and adds simulated answers for all test teams for a single question.
 */
export async function addTestAnswersForQuestion(db, gameCode, q, current, testUserCount = testTeams.length) {
  if (!db || !gameCode || !q) {
    console.error("[Test Data] Aborted: Missing required arguments.");
    return;
  }

  let configuredCount = Math.max(0, Math.min(testTeams.length, Number(testUserCount) || 0));
  if (configuredCount <= 0) {
    console.log("[Test Data] Skipping simulated answers: test user count is 0");
    return;
  }

  const activeTestTeams = testTeams.slice(0, configuredCount);

  await ensureTestTeamsExist(db, gameCode, configuredCount);

  if (!Array.isArray(q.answers)) q.answers = [];
  if (!Array.isArray(q.answersOrder) || q.answersOrder.length !== q.answers.length) {
    q.answersOrder = Array.from({ length: q.answers.length }, (_, i) => i);
  }

  console.log(`[Test Data] Generating answers for Q${current}: ${q.question}`);

  // Read the host’s question start time so we can synthesize realistic submittedAt
  const gameSnap = await getDoc(doc(db, "games", gameCode));
  const gd = gameSnap.data() || {};
  const startTs =
    gd.questionStartTimeServer ||
    gd.questionStartTime ||
    gd.questionStartTimeLegacyMs; // may be a number or a Timestamp
  const startMs =
    (startTs && typeof startTs.toMillis === "function")
      ? startTs.toMillis()
      : (typeof startTs === "number" ? startTs : Date.now());

  const totalSec = Math.max(1, Number(q.time || 20));
  const totalMs = totalSec * 1000;

  const batch = writeBatch(db);

  // --- ADD HELPER FUNCTIONS NEEDED FOR WHEEL SCORING ---
  function normalizeAnswer(s) {
      return (s || "").replace(/[^A-Z0-9]/gi, "").toUpperCase();
  }
  function getSimilarity(a, b) {
      const dp = Array(a.length + 1).fill(null).map(() => Array(b.length + 1).fill(null));
      for (let i = 0; i <= a.length; i++) dp[i][0] = i;
      for (let j = 0; j <= b.length; j++) dp[0][j] = j;
      for (let i = 1; i <= a.length; i++) {
          for (let j = 1; j <= b.length; j++) {
              const cost = a[i - 1] === b[j - 1] ? 0 : 1;
              dp[i][j] = Math.min(dp[i - 1][j] + 1, dp[i][j - 1] + 1, dp[i - 1][j - 1] + cost);
          }
      }
      const distance = dp[a.length][b.length];
      const maxLen = Math.max(a.length, b.length);
      return maxLen === 0 ? 1 : 1 - distance / maxLen;
  }
  // --- END HELPER FUNCTIONS ---

  for (const team of activeTestTeams) {
  try {

      const type = String(q.type || q.CAT || "").toUpperCase();
      const numAnswers = q.answers.length;

      // Simulate submission delay
      const u = Math.random();
      const jitter = Math.floor(Math.random() * 150);
      const delayMs = Math.floor(totalMs * Math.pow(u, 1.0)) + jitter; // Unbiased delay
      const clientSubmitMs = startMs + delayMs;
      const elapsedSec = delayMs / 1000;

      // Base payload mimics Player.js structure
      let answerPayload = {
        q: current,
        team: team.name,
        submittedAt: Timestamp.fromMillis(clientSubmitMs), // Firestore Timestamp
        time: clientSubmitMs,                               // Legacy numeric mirror
        // Fields specific to certain types will be added below
      };

      // --- Simulated Bet (for BETANSWER) ---
      let teamBet = 0;
      if (type === "BETANSWER") {
        teamBet = [0, 5, 10, 15, 20, 25][Math.floor(Math.random() * 6)];
        const teamBetRef = doc(db, "games", gameCode, "teams", team.name);
        // Use update here as ensureTestTeamsExist uses set with merge
        batch.update(teamBetRef, { currentbet: teamBet });
      }
      // --- End Bet Simulation ---

      // Determine simulated correctness based on team accuracy (adjusted for vanishing)
      const baseAcc = Math.max(0, Math.min(1, team.accuracy || 0.5));
      let effAcc = baseAcc;
      let visiblePool = Array.from({ length: numAnswers }, (_, i) => i); // Display indices initially
      if (type === "VANISHINGCHOICE") {
         visiblePool = remainingDisplayIndices(q, elapsedSec);
         effAcc = 1 - (1 - baseAcc) * (visiblePool.length / Math.max(1, numAnswers));
      }
      const willBeCorrect = Math.random() < effAcc;


      switch (type) {
        case "MULTICHOICE":
        case "TRUE/FALSE":
        case "BETANSWER": // Now includes correct/points mimicry
        case "VANISHINGCHOICE": {
          // Find the DISPLAY index of the correct answer (original index 0)
          const correctDisplayIndex = Array.isArray(q.answersOrder) ? q.answersOrder.findIndex(orig => orig === 0) : 0;

          let chosenDisplayIndex;
          if (willBeCorrect && visiblePool.includes(correctDisplayIndex)) {
            chosenDisplayIndex = correctDisplayIndex;
          } else {
            const wrongPool = visiblePool.filter(i => i !== correctDisplayIndex);
            // Pick a random wrong answer, or fallback to correct if none are left/visible
            chosenDisplayIndex = wrongPool.length ? wrongPool[Math.floor(Math.random() * wrongPool.length)] : correctDisplayIndex;
          }

          // Convert chosen DISPLAY index back to ORIGINAL index for submission
          const originalIndex = Array.isArray(q.answersOrder) ? q.answersOrder[chosenDisplayIndex] : chosenDisplayIndex;
          answerPayload.answer = originalIndex;

          // Add fields specific to type, mimicking Player.js
          if (type === "BETANSWER") {
            const isCorrectClientSide = originalIndex === 0;
            answerPayload.correct = isCorrectClientSide;
            answerPayload.points = isCorrectClientSide ? teamBet : -teamBet; // Use simulated bet
          }
          if (type === "VANISHINGCHOICE") {
            answerPayload.visibleOptionsAtAnswer = visiblePool.length;
          }
          // Note: Player.js also adds correct/points for MULTICHOICE & TRUE/FALSE,
          // but host recalculates anyway, so we can omit them here for simplicity unless needed.
          break;
        }

        case "MULTIANSWER": {
          const correctDisplayIndices = Array.isArray(q.answersOrder) ? q.answersOrder.map((origIdx, displayIdx) => (/^\[.*\]$/.test(String(q.answers[origIdx] ?? "")) ? displayIdx : -1)).filter(i => i !== -1) : [0];
          let chosenDisplay = [];
          if (willBeCorrect) { // Use the accuracy-based willBeCorrect
            chosenDisplay = correctDisplayIndices; // Submit all correct if simulating correct
          } else {
            const wrongs = Array.from({ length: numAnswers }, (_, i) => i).filter(i => !correctDisplayIndices.includes(i));
            if (wrongs.length) { chosenDisplay = [wrongs[Math.floor(Math.random() * wrongs.length)]]; } // Submit one random wrong
          }
          const toOriginal = d => (Array.isArray(q.answersOrder) ? q.answersOrder[d] : d);
          answerPayload.answer = chosenDisplay.map(toOriginal); // Array of original indices
          break;
        }

        case "NEARESTANSWER": {
          if (!q.answers || q.answers.length === 0) continue;
          const correctValue = parseFloat(q.answers[0]);
          // Use willBeCorrect for variance, not flat 50%
          const variance = willBeCorrect ? correctValue * 0.05 : correctValue * 0.5;
          answerPayload.answer = Math.round(correctValue + (Math.random() * variance * 2 - variance));
          break;
        }

case "TYPE":
        case "WHEEL":
        case "BREADCRUMBS": {
          if (!q.answers || q.answers.length === 0) continue;

          let submittedAnswerText = "";
          const correctAnswerText = q.answers[0];

          // Determine correctness based on accuracy
          const willBeCorrect = Math.random() < effAcc; // effAcc calculated earlier

          if (willBeCorrect) {
              submittedAnswerText = correctAnswerText;
          } else {
              // Simulate a slightly incorrect answer (e.g., change one letter)
              if (correctAnswerText.length > 0) {
                  const randomIndex = Math.floor(Math.random() * correctAnswerText.length);
                  // Generate a random uppercase letter different from the original
                  let randomChar;
                  do {
                      randomChar = String.fromCharCode(65 + Math.floor(Math.random() * 26));
                  } while (randomChar === correctAnswerText[randomIndex]?.toUpperCase());
                  submittedAnswerText = correctAnswerText.substring(0, randomIndex) + randomChar + correctAnswerText.substring(randomIndex + 1);
              } else {
                  submittedAnswerText = "WRONG"; // Fallback if correct answer is empty
              }
          }

          // Calculate similarity and correct flag (mimicking Player.js)
          const playerAnswerNorm = normalizeAnswer(submittedAnswerText);
          const correctAnswerNorm = normalizeAnswer(correctAnswerText);
          const similarityScore = getSimilarity(playerAnswerNorm, correctAnswerNorm);
          const isCorrectClientSide = similarityScore >= 0.8;

          // Build the exact payload Player.js would send
          answerPayload = {
              ...answerPayload, // Keep base fields: q, team, submittedAt, time
              answer: submittedAnswerText,      // The (potentially modified) string answer
              correct: isCorrectClientSide,     // Calculated boolean
              similarity: similarityScore.toFixed(2), // Calculated string score
          };
          break;
        }

        case "OUTOFORDER": {
          const displayOrder = Array.from({ length: numAnswers }, (_, k) => k); // Start with 0..N-1
          if (!willBeCorrect) { // Use accuracy-based willBeCorrect
            // Shuffle (Fisher–Yates)
            for (let j = displayOrder.length - 1; j > 0; j--) {
              const k2 = Math.floor(Math.random() * (j + 1));
              [displayOrder[j], displayOrder[k2]] = [displayOrder[k2], displayOrder[j]];
            }
          }
          // Map DISPLAY order back to ORIGINAL indices using answersOrder
          const toOriginal = d => (Array.isArray(q.answersOrder) ? q.answersOrder[d] : d);
          answerPayload.answer = displayOrder.map(toOriginal); // Array of original indices
          break;
        }

        default:
          console.warn(`[Test Data] Skipping unsupported question type: ${type}`);
          continue; // Skip unknown types
      }

      // Add the final payload to the batch
      const answerRef = doc(db, "games", gameCode, "answers", `${current}-${team.name}`);
      batch.set(answerRef, answerPayload);

    } catch (error) {
      console.error(`[Test Data] Failed to generate answer for team ${team.name} on Q${current}.`, error);
    }
  } // End loop through teams

  try {
    await batch.commit();
    console.log(`[Test Data] Successfully submitted answers for Q${current}.`);
  } catch (error) {
    console.error(`[Test Data] CRITICAL: Firestore batch commit failed for Q${current}.`, error);
  }
} // End function addTestAnswersForQuestion